var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { useEnterLeaveFunc } from './hooks';
/**
 * `<LeaveGroup>` is designed to container a component that needs to run a
 * function only when the mouse leaves it.
 */
export var LeaveGroup = function (props) {
    var onLeave = props.onLeave, isDisabled = props.isDisabled, delay = props.delay, rest = __rest(props, ["onLeave", "isDisabled", "delay"]);
    var _a = useEnterLeaveFunc(onLeave, isDisabled, delay), enter = _a[0], leave = _a[1];
    return (React.createElement("div", __assign({ onMouseEnter: enter, onMouseLeave: leave }, rest), props.children));
};
//# sourceMappingURL=LeaveGroup.js.map